import { faEdit, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { TextField } from 'src/components/TextField';
import { useSession } from 'src/contexts/SessionContext';
import { BaseSelect } from 'src/shared/Forms/Selects/BaseSelect';

import { FilterTypeComponentProps } from './types';

export const FilterTypeTag: FC<FilterTypeComponentProps> = ({
  value,
  onChange,
  onDelete,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'reminderFilters.filterSet',
  });
  const { session } = useSession();

  const clientTags = session?.clientTags ?? [];
  const options = clientTags.map((t) => ({
    id: t,
    label: t,
  }));

  const [editing, setEditing] = useState(false);

  const handleToggle = () => setEditing((e) => !e);

  return (
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      {editing ? (
        <>
          {t('are')}
          <TextField
            size="medium"
            value={value.negate ? 'not' : 'is'}
            onChange={(e) =>
              onChange({ ...value, negate: e.target.value === 'not' })
            }
            options={[
              { value: 'is', label: t('tagged') },
              { value: 'not', label: t('notTagged') },
            ]}
            sx={{ minWidth: 100 }}
          />
          {t('with')}
          <BaseSelect
            value={value.value || []}
            onChange={(v) => onChange({ ...value, value: v || null })}
            options={options}
            placeholder={t('addTags')}
            sx={{ minWidth: 200 }}
            multiple
          />
          <Button color="primary" variant="prominent" onClick={handleToggle}>
            {t('done')}
          </Button>
        </>
      ) : (
        <Box gap={1}>
          {t('are')} {value.negate && t('not')}{' '}
          {value.value?.length
            ? `${t('taggedWith')} "${(typeof value.value === 'string'
                ? [value.value]
                : value.value
              ).join(', ')}"`
            : t('taggedWithAnything')}
          <IconButton size="small" color="primary" onClick={handleToggle}>
            <Icon icon={faEdit} size="small" />
          </IconButton>
          <IconButton size="small" color="error" onClick={() => onDelete()}>
            <Icon icon={faTrash} size="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
